import React, {useEffect, useCallback, useState} from 'react'
import {Header} from '../../components/Header/Header'
import classes from './CompanyPage.module.css'
import {FiFacebook, FiGlobe, FiLinkedin, FiUsers} from 'react-icons/fi'
import {NavText} from '../../components/NavElements'
import {JobCard} from '../../components/JobCard/JobCard'
import {Button} from '../../components/Button/Button'
import styled from 'styled-components'
import {useMediaQuery} from '@material-ui/core'
import {useParams} from "react-router-dom";
import {serverConn} from "../../API/apiRequest";
import TimeAgo from 'javascript-time-ago'
import {Job} from "../../Authenticated/Employee/Types/Job";
import {Loading} from "../../components/Loading/Loading";

interface Props {
}

const Global = styled(FiGlobe)`
  color: #BBBBBB;
  transition: color 0.3s ease;

  &:hover {
    color: white;
  }
`
const FB = styled(FiFacebook)`
  color: #BBBBBB;
  transition: color 0.3s ease;

  &:hover {
    color: white;
  }
`
const LI = styled(FiLinkedin)`
  color: #BBBBBB;
  transition: color 0.3s ease;

  &:hover {
    color: white;
  }
`

interface Props {
    without?: boolean,
    withoutHeader?: boolean,
    data?: Array<Job>
}

export const CompanyPage: React.FC<Props> = (props) => {
    const timeAgo = new TimeAgo('ar-EG')
    const matches = useMediaQuery('(max-width:510px)');
    let Params: any = useParams()
    const [CompanyData, setCompanyData] = useState<{
        id: string,
        description: string,
        employees: string,
        facebook: string,
        field: string,
        linkedIn: string,
        picture: string,
        title: string,
        website: string,
    }>();
    const [Load, setLoad] = useState<boolean>(true);
    const [hasNext, sethasNext] = useState(true);
    const [Jops, setJops] = useState<{
        companyImage: string,
        companyName: string,
        createdAt: string,
        field: string,
        id: string,
        title: string,
        type: string,
    }[]>([]);
    const [page, setpage] = useState(1);
    const [totalJobs, settotalJobs] = useState();
    const getjops = useCallback((num: number) => {
        serverConn.get(`/jobs/owner/${Params.id}/job?page=${num}`).then((res) => {
            setJops(res.data.jobs)
            sethasNext(res.data.hasNext)
            settotalJobs(res.data.totalJobs)
        })
    }, [Params.id]);
    useEffect(() => {
        setLoad(true)
        serverConn.get(`/jobs/owner/${Params.id}`).then((res) => {
            if(res.status === 200) {
                setCompanyData(res.data)
                setLoad(false)
            }
        })
        getjops(page);
    }, [Params.id, page, getjops])
    return (
            <React.Fragment>
                {Load ? (<div className={'loadingfull'}><Loading/></div>) : (
                        <>

                            {props.withoutHeader ? ("") : (
                                    <Header/>)}
                            <div className={classes.coverImage}>
                                <div className={classes.darker}/>
                                <div className={classes.about}>
                                    <div className={'d-flex align-items-center ' + classes.first}>
                                        <img src={CompanyData && CompanyData.picture} className={classes.image}
                                             alt={CompanyData && CompanyData.title}/>
                                        <div className={"pe-3 " + classes.companyText}>
                                            <p className={classes.title}>{CompanyData && CompanyData.title}</p>
                                            <p className={classes.des}>{CompanyData && CompanyData.description}</p>
                                        </div>
                                    </div>
                                    <div className={classes.second}>
                                        <div className={classes.moreInfo}>
                                            <div className={classes.element}>
                                                <p className={classes.field}>:المجال</p>
                                                <p className={classes.fieldText}>{CompanyData && CompanyData.field}</p>
                                            </div>
                                            <div className={classes.element}>
                                                <FiUsers color='#BBBBBB' size={23}/>
                                                <p className={classes.counter}>{CompanyData && CompanyData.employees}</p>
                                            </div>
                                        </div>
                                        <div className={classes.social}>
                                            {CompanyData && CompanyData.website && (
                                                    <Global size={matches ? 27 : 37}
                                                            onClick={() => window.open(CompanyData.website)}/>
                                            )}
                                            {CompanyData && CompanyData.facebook && (
                                                    <FB size={matches ? 27 : 37}
                                                        onClick={() => window.open(CompanyData.facebook)}/>
                                            )
                                            }
                                            {CompanyData && CompanyData.linkedIn && (
                                                    <LI size={matches ? 27 : 37}
                                                        onClick={() => window.open(CompanyData.linkedIn)}/>
                                            )
                                            }

                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className={classes.ground}>
                                <div className={classes.jobsR}>
                                    <div className={classes.jobs}>
                                        <div className={classes.head}>
                                            <p className={classes.companyJobs}> <span className={classes.jobsNumber}>{totalJobs}</span>  وظيفة متاحة من {CompanyData && CompanyData.title}  </p>
                                       
                                        </div>
                                        <div className={classes.jobsCard}>
                                            {Jops && Jops.length > 0 ? Jops.map((j, index) =>
                                                    <NavText key={index} to={{
                                                        pathname: `${window.location.href.includes('employee') ? `/employee/job/${j.id}` : `/job/${j.id}`}`,
                                                        state: {without: props.without}
                                                    }}>
                                                        <JobCard
                                                                title={j.title}
                                                                companyName={j.companyName}
                                                                //companyIcon={j.companyImage}
                                                                CompanyImage={j.companyImage}
                                                                time={(timeAgo.format(Date.now() - (Date.now() - new Date(j.createdAt).getTime()))).toString().replace("قبل", '')}
                                                                //      views={j.views}
                                                                jobCategory={j.field}
                                                                jobTime={j.type}
                                                        /></NavText>) : ""}

                                            <div className={classes.pages}>
                                                <Button width={matches ? 150 : undefined}
                                                        height={matches ? 38 : undefined}
                                                        disabled={!hasNext}
                                                        onPress={() => {
                                                            if(hasNext) {
                                                                let num = page;
                                                                num++;
                                                                setpage(num);
                                                                getjops(num)
                                                            }
                                                        }}
                                                        color='black'>التالي</Button>

                                                <Button width={matches ? 150 : undefined}
                                                        height={matches ? 38 : undefined}
                                                        disabled={page <= 1}
                                                        onPress={() => {
                                                            if(page > 1) {
                                                                let num = page;
                                                                num--;
                                                                setpage(num);
                                                                getjops(num)
                                                            }
                                                        }}
                                                        color='black'>السابق</Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                )}
            </React.Fragment>
    )
}